/* eslint-disable jsdoc/require-jsdoc */

class GeneradorDeSecuencia{

    static generador;

    static primerNroSecuencial(){
        const crearGenerador = function* () {
            let actual = 1;
            while (true) { // Bucle infinito seguro porque el generador pausa en cada yield
                yield actual++;
            }
        };
        GeneradorDeSecuencia.generador = crearGenerador();
        return GeneradorDeSecuencia.generador.next().value;
    }

    static siguienteNroSecuencial(){
        if(GeneradorDeSecuencia.generador){
            return GeneradorDeSecuencia.generador.next().value;
        }
        return null;
    }



}

export default GeneradorDeSecuencia;